/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { arr_inArray, clip, str_trim, x_split } from './util.js';
import { $ } from '../other/jquery-ui-hooked.js';

import '../vendor/select2.js';


$.fn.select2.amd.define( 'mjSelect2TreeSelectionAdapter', [
	'select2/utils',
	'select2/selection/multiple',
	'select2/selection/placeholder',
	'select2/selection/eventRelay',
	'select2/selection/single',
], function( Utils, MultipleSelection, Placeholder, EventRelay, SingleSelection ) {

	// Decorates MultipleSelection with Placeholder
	var adapter = Utils.Decorate( SingleSelection, Placeholder );
	// Decorates adapter with EventRelay - ensures events will continue to fire
	// e.g. selected, changed
	adapter = Utils.Decorate( adapter, EventRelay );

	adapter.prototype.render = function() {
		// Use selection-box from SingleSelection adapter
		// This implementation overrides the default implementation
		var $selection = SingleSelection.prototype.render.call( this );
		return $selection;
	};

	adapter.prototype.update = function( data ) {
		// copy and modify SingleSelection adapter
		this.clear();

		var $rendered = this.$selection.find('>.select2-selection__rendered');
		var formatted;
		var title = '';

		var noItemsSelected = data.length===0;
		if( noItemsSelected ) {
			formatted = this.options.get('placeholder') || '';
		} else {
			var selection = data[0];
			var crumbs = this.broadcrumb(selection.parent);
			var entity = this.display(selection,$rendered);
			title = selection.title || selection.text;
			if( this.options.get('showEntityIds') && selection.id ) {
				title += ' (ID ' + selection.id + ')';
				entity += ' <span class="s2-opt-id-str">(ID ' + selection.id + ')</span>';
			}
			formatted = [crumbs,'<span class="select2-tree-selection">'+entity+'</span>'];
		}

		$rendered
			.empty()
			.prop('title',title)
			.addClass('select2-tree')
			.append(formatted);
	};

	adapter.prototype.broadcrumb = function( id ) {

		function prependCrumb( container, text ) {
			var span2 = document.createElement('span');
			span2.className = 'select2-tree-bc-segment';
			if( text!=null ) span2.appendChild( document.createTextNode(text) );

			var span1 = document.createElement('span');
			span1.className = 'select2-tree-breadcrumb';
			span1.appendChild(span2);

			container.insertBefore(span1,container.firstChild);
		}

		var crumb = document.createElement('span');
		crumb.className = 'select2-tree-breadcrumbs';

		if( id!==false ) {
			var self = this;
			var dataAdapter = self.container.dataAdapter;

			var findOption = function( id ) {
				var optionElem = self.$element.find('>option[value='+id+']');
				return optionElem.length ? dataAdapter.item(optionElem[0]) : null;
			};

			var parent = id;
			while( parent!==false ) {
				var item = findOption(parent);
				if( item==null ) break; // parent is missing
				prependCrumb(crumb,item.text);
				parent = item.parent;
			}
		}
		prependCrumb(crumb,null);
		return crumb;
	};

	return adapter;
} );


$.fn.select2.amd.define( 'mjSelect2TreeDataAdapter', [
	'select2/data/base',
	'select2/utils',
	'jquery',
], function( BaseAdapter, Utils, $ ) {

	function Select2TreeDataAdapter( $element, options ) {
		this.$element = $element;
		this.options = options;
		Select2TreeDataAdapter.__super__.constructor.call( this );
		this.parent = false;
		this.traversing = false;
	}

	Utils.Extend( Select2TreeDataAdapter, BaseAdapter );


	Select2TreeDataAdapter.prototype.startTraversal = function() {
		this.traversing = true;
	};
	Select2TreeDataAdapter.prototype.finishTraversal = function() {
		this.traversing = false;
	};
	Select2TreeDataAdapter.prototype.isInTraversal = function() {
		return this.traversing;
	};

	Select2TreeDataAdapter.prototype.current = function( callback ) {
		var data = [];
		var self = this;
		this.$element.find('>option:selected').each( function() {
			var option = self.item(this);
			if( !self.traversing ) {
				self.parent = option.parent || false;
			}
			data.push(option);
		} );
		callback(data);
	};

	Select2TreeDataAdapter.prototype.select = function( data ) {
		var self = this;
		data.selected = true;
		// If data.element is a DOM node, use it instead
		if( $( data.element ).is( 'option' ) ) {
			data.element.selected = true;
			this.$element.trigger( 'change' );
			return;
		}
		if( this.$element.prop( 'multiple' ) ) {
			this.current( function( currentData ) {
				var val = [];
				data = [data];
				data.push.apply( data, currentData );
				for( var d = 0; d < data.length; d++ ) {
					var id = data[d].id;
					if( arr_inArray( id, val ) === -1 ) {
						val.push( id );
					}
				}
				self.$element.val( val );
				self.$element.trigger( 'change' );
			} );
		} else {
			var val = data.id;
			this.$element.val( val );
			this.$element.trigger( 'change' );
		}
	};

	Select2TreeDataAdapter.prototype.unselect = function( data ) {
		var self = this;
		if( !this.$element.prop( 'multiple' ) ) {
			return;
		}
		data.selected = false;
		if( $( data.element ).is( 'option' ) ) {
			data.element.selected = false;
			this.$element.trigger( 'change' );
			return;
		}
		this.current( function( currentData ) {
			var val = [];
			for( var d = 0; d < currentData.length; d++ ) {
				var id = currentData[d].id;
				if( id !== data.id && arr_inArray( id, val ) === -1 ) {
					val.push( id );
				}
			}
			self.$element.val( val );
			self.$element.trigger( 'change' );
		} );
	};

	Select2TreeDataAdapter.prototype.bind = function( container, $container ) {
		var self = this;
		this.container = container;
		container.on( 'select', function( params ) {
			self.select( params.data );
		} );
		container.on( 'unselect', function( params ) {
			self.unselect( params.data );
		} );
	};
	Select2TreeDataAdapter.prototype.destroy = function() {
		// Remove anything added to child elements
		this.$element.find( '*' ).each( function() {
			// Remove any custom data set by Select2
			Utils.RemoveData( this );
		} );
	};

	Select2TreeDataAdapter.prototype.query = function( params, callback ) {
		//console.time('Select2TreeDataAdapter::query');

		var self = this;
		if( params.term!==undefined && str_trim(params.term)!=='' ) {
			self.parent = true;
		} else if( self.parent===true ) {
			self.parent = false;
		}
		var data = [];
		var parsedoptions = {};
		var parents = {};

		//console.timeLog('Select2TreeDataAdapter::query');

		this.$element.find('>option,>optgroup').each( function() {
			var option = self.item(this);
			parsedoptions[option.id] = option;

			if( option.parent ) {
				if( parsedoptions[option.parent]==undefined ) {
					option.parent = false;
				} else {
					var cur_parent = option.parent;
					while( cur_parent!==false && parents[cur_parent]==undefined ) {
						if( parsedoptions[cur_parent]==undefined ) break;
						parents[cur_parent] = parsedoptions[cur_parent];
						cur_parent = parents[cur_parent].parent;
					}
				}
			}

			var matches = self.matches(params,option);
			if( matches!==null ) data.push(matches);
		} );

		//console.timeLog('Select2TreeDataAdapter::query');

		callback( {
			results: data,
			parents: parents,
		} );

		//console.timeEnd('Select2TreeDataAdapter::query');
	};

	Select2TreeDataAdapter.prototype.addOptions = function( $options ) {
		Utils.appendMany( this.$element, $options );
	};

	Select2TreeDataAdapter.prototype.option = function( data ) {
		var option;
		if( data.children ) {
			option = document.createElement( 'optgroup' );
			option.label = data.text;
		} else {
			option = document.createElement( 'option' );
			option.textContent = data.text;
		}
		if( data.id !== undefined ) {
			option.value = data.id;
		}
		if( data.disabled ) {
			option.disabled = true;
		}
		if( data.selected ) {
			option.selected = true;
		}
		if( data.title ) {
			option.title = data.title;
		}
		var normalizedData = this._normalizeItem( data );
		normalizedData.element = option;
		Utils.StoreData( option, 'data', normalizedData );
		return $( option );
	};

	Select2TreeDataAdapter.prototype.item = function( $option ) {
		var option_elem = ( $option instanceof $ ) ? $option[0] : $option;
		var data = Utils.GetData(option_elem,'data');
		if( data!=null ) return data;
		if( option_elem.tagName==='OPTION' ) {
			var parent = $(option_elem).data('parent');
			data = {
				id: option_elem.value,
				text: option_elem.textContent,
				disabled: option_elem.disabled,
				selected: option_elem.selected,
				title: option_elem.title,
				parent: parent !== undefined ? parent : false,
			};
		} else if( option_elem.tagName==='OPTGROUP' ) {
			data = {
				text: option_elem.label,
				children: [],
				title: option_elem.title,
			};
			var $children = $(option_elem).find('>option');
			var children = [];
			for( var c=0; c<$children.length; ++c ) {
				children.push( this.item($children[c]) );
			}
			data.children = children;
		}
		data = this._normalizeItem(data);
		data.element = option_elem;
		Utils.StoreData(option_elem,'data',data);
		return data;
	};

	Select2TreeDataAdapter.prototype._normalizeItem = function( item ) {
		if( item !== Object(item) ) {
			item = {
				id: item,
				text: item,
			};
		}
		item = Object.assign(
			{
				text:''
			},
			item
		);
		if( item.id!=null && typeof item.id !== 'string' ) {
			item.id = item.id.toString();
		}
		if( item.text!=null && typeof item.text !== 'string' ) {
			item.text = item.text.toString();
		}
		if( item._resultId==null && item.id && this.container!=null ) {
			item._resultId = this.generateResultId(this.container,item);
		}
		return Object.assign(
			{
				selected: false,
				disabled: false,
				parent: false
			},
			item
		);
	};

	// optimized version of BaseAdapter.prototype.generateResultId():
	Select2TreeDataAdapter.prototype.generateResultId = function( container, data ) {
		function Utils_generateChars( length ) {
			var chars = '';
			for( ; length>0; --length ) chars += Math.floor(Math.random()*36).toString(36);
			return chars;
		}
		return container.id
				+'-result-'
				+Utils_generateChars(4)
				+'-'
				+( data.id==null ? Utils_generateChars(4) : data.id.toString() );
	};


	Select2TreeDataAdapter.prototype.matches = function( params, data ) {
		var matcher = this.options.get('matcher');
		return matcher(params,data);
	};

	return Select2TreeDataAdapter;
} );


$.fn.select2.amd.define( 'mjSelect2TreeResultsAdapter', [
	'jquery',
	'select2/utils',
], function( $, Utils ) {

	function Select2TreeResultsAdapter( $element, options, dataAdapter ) {
		this.$element = $element;
		this.data = dataAdapter;
		this.options = options;
		this.showParent = 0;
		Select2TreeResultsAdapter.__super__.constructor.call( this );
	}

	Utils.Extend( Select2TreeResultsAdapter, Utils.Observable );

	Select2TreeResultsAdapter.prototype.render = function() {
		var $results = $( '<ul class="select2-results__options select2-tree-nodes-view" role="tree"></ul>' );
		if( this.options.get( 'multiple' ) ) $results.attr( 'aria-multiselectable', 'true' );
		if( this.options.get( 'tree' ) ) $results.attr( 'aria-tree', 'true' );
		this.$results = $results;
		return $results;
	};
	Select2TreeResultsAdapter.prototype.clear = function() {
		this.$results.empty();
	};
	Select2TreeResultsAdapter.prototype.displayMessage = function( params ) {
		var escapeMarkup = this.options.get( 'escapeMarkup' );
		this.clear();
		this.hideLoading();
		var $message = $( '<li role="treeitem" aria-live="assertive" class="select2-results__option select2-tree-node"></li>' );
		var message = this.options.get( 'translations' ).get( params.message );
		$message.append( escapeMarkup( message( params.args ) ) );
		$message[0].className += ' select2-results__message';
		this.$results.append( $message );
	};
	Select2TreeResultsAdapter.prototype.hideMessages = function() {
		this.$results.find( '.select2-results__message' ).remove();
	};
	Select2TreeResultsAdapter.prototype.append = function( data ) {
		this.hideLoading();
		var $options = [];
		if( data.results == null || data.results.length === 0 ) {
			if( this.$results.children().length === 0 ) {
				this.trigger( 'results:message', { message: 'noResults' } );
			}
			return;
		}
		data.results = this.sort( data.results );
		if( this.data.parent !== true ) {
			// means: the parent of all result items is the same,
			// show path for all items
			this.$results.append( this.path( this.data.parent, data.parents, true ) );
		}
		var last_items_parent = null;

		for( var d = 0; d < data.results.length; d++ ) {
			var item = data.results[d];
			if( this.data.parent !== true && this.data.parent != item.parent ) continue;
			if( data.parents[item.id] != undefined ) item.hasChilds = true;
			var $option = this.option( item );

			if( this.data.parent === true ) {
				// means: the parents of result items differ,
				// show path for each result item,
				// except if path is the same as of last item
				if( item.parent !== last_items_parent ) {
					this.$results.append( this.path( item.parent, data.parents, false ) );
					last_items_parent = item.parent;
				}
				this.$results.append( $option );
			}

			$options.push( $option );
		}
		if( this.data.parent !== true ) this.$results.append( $options );
	};
	Select2TreeResultsAdapter.prototype.position = function( $results, $dropdown ) {
		var $resultsContainer = $dropdown.find( '.select2-results' );
		$resultsContainer.append( $results );
	};
	Select2TreeResultsAdapter.prototype.sort = function( data ) {
		var sorter = this.options.get( 'sorter' );
		return sorter( data );
	};
	Select2TreeResultsAdapter.prototype.highlightFirstItem = function() {
		var $options = this.$results
			.find( '.select2-results__option[aria-selected]' );
		var $selected = $options.filter( '[aria-selected=true]' );
		// Check if there are any selected options
		if( $selected.length > 0 ) {
			// If there are selected options, highlight the first
			$selected.first().trigger( 'mouseenter' );
		} else {
			// If there are no selected options, highlight the first option
			// in the dropdown
			$options.first().trigger( 'mouseenter' );
		}
		this.ensureHighlightVisible();
	};
	Select2TreeResultsAdapter.prototype.setClasses = function() {
		var self = this;
		this.data.current( function( selected ) {
			var selectedIds = selected.map( function( s ) {
				return s.id.toString();
			} );
			var $options = self.$results.find( '.select2-results__option[aria-selected]' );
			$options.each( function() {
				var $option = $( this );
				var item = Utils.GetData( this, 'data' );
				// id needs to be converted to a string when comparing
				var id = '' + item.id;
				if( ( item.element != null && item.element.selected ) || ( item.element == null && arr_inArray( id, selectedIds ) > -1 ) ) {
					$option.attr( 'aria-selected', 'true' );
				} else {
					$option.attr( 'aria-selected', 'false' );
				}
			} );
		} );
	};
	Select2TreeResultsAdapter.prototype.showLoading = function( params ) {
		this.hideLoading();
		var loadingMore = this.options.get( 'translations' ).get( 'searching' );
		var loading = {
			disabled: true,
			loading: true,
			text: loadingMore( params ),
		};
		var $loading = this.option( loading );
		$loading.className += ' loading-results';
		this.$results.prepend( $loading );
	};
	Select2TreeResultsAdapter.prototype.hideLoading = function() {
		this.$results.find( '.loading-results' ).remove();
	};
	Select2TreeResultsAdapter.prototype.path = function( id, parents, of_whole_list ) {
		var self = this;
		var crumb = document.createElement( 'li' );
		crumb.className = 'select2-results__option select2-tree-path' + ( of_whole_list ? ' select2-tree-path-of-whole-result-list' : '' );
		var parent = id;
		while( parent !== false && parent !== true ) {
			var item = parents[parent];
			var segment = $( '<span class="select2-tree-path-segment" data-id="' + item.id + '"></span>' ).html( $( '<span class="select2-tree-bc-segment"></span>' ).text( item.text ) ).prependTo( crumb );
			if( of_whole_list && id === parent ) {
				// last segment: not linked
			} else {
				segment.addClass( 'link' ).on( 'click', function( evt ) {
					self.data.parent = $( this ).data( 'id' );
					self.data.startTraversal();
					self.data.container.close();
					self.data.container.open();
					self.data.finishTraversal();
				} );
			}
			parent = item.parent;
		}
		$( '<span class="select2-tree-path-segment link"><span class="select2-tree-bc-segment">&nbsp;&nbsp;&nbsp;</span></span>' ).on( 'click', function( evt ) {
			self.data.parent = false;
			self.data.startTraversal();
			self.data.container.close();
			self.data.container.open();
			self.data.finishTraversal();
		} ).prependTo( crumb );
		return crumb;
	};
	Select2TreeResultsAdapter.prototype.option = function( data ) {
		var option = document.createElement( 'li' );
		option.className = 'select2-results__option select2-tree-node';
		var attrs = {
			'role': 'treeitem',
			'aria-selected': 'false',
		};
		if( data.disabled ) {
			delete attrs['aria-selected'];
			attrs['aria-disabled'] = 'true';
		}
		if( data.id == null ) {
			delete attrs['aria-selected'];
		}
		if( data._resultId != null ) {
			option.id = data._resultId;
		}
		if( data.title ) {
			option.title = data.title;
		}
		if( data.children ) {
			attrs.role = 'group';
			attrs['aria-label'] = data.text;
			delete attrs['aria-selected'];
		}
		if( data.parent ) {
			attrs['aria-parent'] = data.parent;
		}
		if( data.hasChilds ) attrs['aria-id'] = data.id;
		for( var attr in attrs ) {
			if( !attrs.hasOwnProperty(attr) ) continue;
			option.setAttribute(attr,attrs[attr]);
		}
		if( data.children ) {
			var $option = $( option );
			var label = document.createElement( 'strong' );
			label.className = 'select2-results__group';
			//var $label = $(label);
			this.template( data, label );
			var $children = [];
			for( var c = 0; c < data.children.length; c++ ) {
				var $child = this.option( data.children[c] );
				$children.push( $child );
			}
			var $childrenContainer = $( '<ul></ul>', { 'class': 'select2-results__options select2-tree-nodes-view select2-results__options--nested' } );
			$childrenContainer.append( $children );
			$option.append( label );
			$option.append( $childrenContainer );
		} else {
			data.class = 'select2-tree-child-title';
			this.template( data, option );
			var self = this;
			if( data.hasChilds ) {
				$( '<span class="select2-tree-child-go"></span>' ).on( 'mouseup', function( evt ) {
					var $li = $( this ).closest( 'li' );
					var new_parent = $li.attr( 'aria-id' );
					/* prevent Select2 from doing "select2:selecting","select2:unselecting","select2:closing" */
					if( evt.stopPropagation ) evt.stopPropagation();
					else evt.bubbles = true;
					if( evt.preventDefault ) evt.preventDefault();
					if( new_parent != undefined ) self.data.parent = new_parent;
					else self.data.parent = false;
					self.data.startTraversal();
					//self.data.container.val(false);
					self.data.container.close();
					self.data.container.open();
					self.data.finishTraversal();
				} ).prependTo( option );
			} else {
				$( '<span class="select2-tree-child-no"></span>' ).on( 'mouseup', function( evt ) {
					evt.stopPropagation();
				} ).prependTo( option );
			}
		}
		Utils.StoreData( option, 'data', data );
		return option;
	};

	Select2TreeResultsAdapter.prototype.bind = function( container, $container ) {
		var self = this;
		var id = container.id + '-results';
		this.$results.attr( 'id', id );
		container.on( 'results:all', function( params ) {
			self.clear();
			self.append( params.data );
			if( container.isOpen() ) {
				self.setClasses();
				self.highlightFirstItem();
			}
		} );
		container.on( 'results:append', function( params ) {
			self.append( params.data );
			if( container.isOpen() ) {
				self.setClasses();
			}
		} );
		container.on( 'query', function( params ) {
			self.hideMessages();
			self.showLoading( params );
		} );
		container.on( 'select', function() {
			if( !container.isOpen() ) {
				return;
			}
			self.setClasses();
			self.highlightFirstItem();
		} );
		container.on( 'unselect', function() {
			if( !container.isOpen() ) {
				return;
			}
			self.setClasses();
			self.highlightFirstItem();
		} );
		container.on( 'open', function() {
			// When the dropdown is open, aria-expended="true"
			self.$results.attr( 'aria-expanded', 'true' );
			self.$results.attr( 'aria-hidden', 'false' );
			self.setClasses();
			self.ensureHighlightVisible();
		} );
		container.on( 'close', function() {
			// When the dropdown is closed, aria-expended="false"
			self.$results.attr( 'aria-expanded', 'false' );
			self.$results.attr( 'aria-hidden', 'true' );
			self.$results.removeAttr( 'aria-activedescendant' );
		} );
		container.on( 'results:toggle', function() {
			var $highlighted = self.getHighlightedResults();
			if( $highlighted.length === 0 ) {
				return;
			}
			$highlighted.trigger( 'mouseup' );
		} );
		container.on( 'results:select', function() {
			var $highlighted = self.getHighlightedResults();
			if( $highlighted.length === 0 ) {
				return;
			}
			var data = Utils.GetData( $highlighted[0], 'data' );
			if( $highlighted.attr( 'aria-selected' ) == 'true' ) {
				self.trigger( 'select', { data: data } );
			} else {
				self.trigger( 'select', { data: data } );
			}
		} );
		container.on( 'results:previous', function() {
			var $highlighted = self.getHighlightedResults();
			var $options = self.$results.find( '[aria-selected]' );
			var currentIndex = $options.index( $highlighted );

			// If we are already at te top, don't move further
			if( currentIndex === 0 ) {
				return;
			}

			var nextIndex = currentIndex - 1;

			// If none are highlighted, highlight the first
			if( $highlighted.length === 0 ) {
				nextIndex = 0;
			}

			var $next = $options.eq( nextIndex );
			$next.trigger( 'mouseenter' );
			var currentOffset = self.$results.offset().top;
			var nextTop = $next.offset().top;
			var nextOffset = self.$results.scrollTop() + ( nextTop - currentOffset );

			if( nextIndex === 0 ) {
				self.$results.scrollTop( 0 );
			} else if( nextTop - currentOffset < 0 ) {
				self.$results.scrollTop( nextOffset );
			}
		} );

		container.on( 'results:next', function() {
			var $highlighted = self.getHighlightedResults();
			var $options = self.$results.find( '[aria-selected]' );
			var currentIndex = $options.index( $highlighted );
			var nextIndex = currentIndex + 1;

			// If we are at the last option, stay there
			if( nextIndex >= $options.length ) {
				return;
			}

			var $next = $options.eq( nextIndex );
			$next.trigger( 'mouseenter' );
			var currentOffset = self.$results.offset().top + self.$results.outerHeight( false );
			var nextBottom = $next.offset().top + $next.outerHeight( false );
			var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

			if( nextIndex === 0 ) {
				self.$results.scrollTop( 0 );
			} else if( nextBottom > currentOffset ) {
				self.$results.scrollTop( nextOffset );
			}
		} );

		container.on( 'results:focus', function( params ) {
			params.element.addClass( 'select2-results__option--highlighted' );
		} );

		container.on( 'results:message', function( params ) {
			self.displayMessage( params );
		} );

		if( $.fn.mousewheel ) {
			this.$results.on( 'mousewheel', function( e ) {
				var top = self.$results.scrollTop();
				var bottom = self.$results.get( 0 ).scrollHeight - top + e.deltaY;
				var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
				var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

				if( isAtTop ) {
					self.$results.scrollTop( 0 );
					e.preventDefault();
					e.stopPropagation();
				} else if( isAtBottom ) {
					self.$results.scrollTop(
						self.$results.get( 0 ).scrollHeight - self.$results.height()
					);
					e.preventDefault();
					e.stopPropagation();
				}
			} );
		}

		this.$results.on( 'mouseup', '.select2-results__option[aria-selected]', function( evt ) {
			var $this = $( this );
			var data = Utils.GetData( this, 'data' );

			if( $this.attr( 'aria-selected' ) === 'true' ) {
				if( self.options.get( 'multiple' ) ) {
					self.trigger( 'unselect', {
						originalEvent: evt,
						data: data,
					} );
				} else {
					self.trigger( 'select', {
						data: data,
					} );
				}
				return;
			}

			self.trigger( 'select', {
				originalEvent: evt,
				data: data,
			} );
		} );

		this.$results.on( 'mouseenter', '.select2-results__option[aria-selected]', function( evt ) {
			var data = Utils.GetData( this, 'data' );
			self.getHighlightedResults().removeClass( 'select2-results__option--highlighted' );

			self.trigger( 'results:focus', {
				data: data,
				element: $( this ),
			} );
		} );
	};

	Select2TreeResultsAdapter.prototype.getHighlightedResults = function() {
		var $highlighted = this.$results.find( '.select2-results__option--highlighted' );

		return $highlighted;
	};

	Select2TreeResultsAdapter.prototype.destroy = function() {
		this.$results.remove();
	};

	Select2TreeResultsAdapter.prototype.ensureHighlightVisible = function() {
		var $highlighted = this.getHighlightedResults();

		if( $highlighted.length === 0 || this.data.isInTraversal() ) {
			return;
		}

		var $options = this.$results.find( '[aria-selected]' );
		var currentIndex = $options.index( $highlighted );
		var currentOffset = this.$results.offset().top;
		var nextTop = $highlighted.offset().top;
		var nextOffset = this.$results.scrollTop() + ( nextTop - currentOffset );
		var offsetDelta = nextTop - currentOffset;
		nextOffset -= $highlighted.outerHeight( false ) * 2;

		if( currentIndex <= 2 ) {
			this.$results.scrollTop( 0 );
		} else if( offsetDelta > this.$results.outerHeight() || offsetDelta < 0 ) {
			this.$results.scrollTop( nextOffset );
		}
	};

	Select2TreeResultsAdapter.prototype.template = function( result, container ) {
		//var self = this;
		var template = this.options.get( 'templateResult' );
		var escapeMarkup = this.options.get( 'escapeMarkup' );
		var content = template( result, container );
		if( content == null ) {
			container.style.display = 'none';
		} else if( typeof content === 'string' ) {
			container.innerHTML = escapeMarkup( content );
		} else {
			if( this.options.get( 'showEntityIds' ) && result.id ) content.append( ' <span class="s2-opt-id-str">(ID ' + result.id + ')</span>' );
			$( container ).append( content );
		}
	};

	return Select2TreeResultsAdapter;
} );

$.fn.select2.amd.define( 'mjSelect2CollectionResultsAdapter', [
	'jquery',
	'select2/utils',
], function( $, Utils ) {

	function Select2CollectionResultsAdapter( $element, options, dataAdapter ) {
		this.$element = $element;
		this.data = dataAdapter;
		this.options = options;
		Select2CollectionResultsAdapter.__super__.constructor.call( this );
	}

	Utils.Extend( Select2CollectionResultsAdapter, Utils.Observable );

	Select2CollectionResultsAdapter.prototype.render = function() {
		var $results = $( '<ul class="select2-results__options" role="tree"></ul>' );
		if( this.options.get( 'multiple' ) ) $results.attr( 'aria-multiselectable', 'true' );
		this.$results = $results;
		return $results;
	};
	Select2CollectionResultsAdapter.prototype.clear = function() {
		this.$results.empty();
	};
	Select2CollectionResultsAdapter.prototype.displayMessage = function( params ) {
		var escapeMarkup = this.options.get( 'escapeMarkup' );
		this.clear();
		this.hideLoading();
		var $message = $( '<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>' );
		var message = this.options.get( 'translations' ).get( params.message );
		$message.append( escapeMarkup( message( params.args ) ) );
		$message[0].className += ' select2-results__message';
		this.$results.append( $message );
	};
	Select2CollectionResultsAdapter.prototype.hideMessages = function() {
		this.$results.find( '.select2-results__message' ).remove();
	};
	Select2CollectionResultsAdapter.prototype.append = function( data ) {
		this.hideLoading();
		var $options = [];
		if( data.results == null || data.results.length === 0 ) {
			if( this.$results.children().length === 0 ) {
				this.trigger( 'results:message', { message: 'noResults' } );
			}
			return;
		}
		data.results = this.sort( data.results );
		for( var d = 0; d < data.results.length; d++ ) {
			var item = data.results[d];
			var $option = this.option( item );
			$options.push( $option );
		}
		this.$results.append( $options );
	};
	Select2CollectionResultsAdapter.prototype.position = function( $results, $dropdown ) {
		var $resultsContainer = $dropdown.find( '.select2-results' );
		$resultsContainer.append( $results );
	};
	Select2CollectionResultsAdapter.prototype.sort = function( data ) {
		var sorter = this.options.get( 'sorter' );
		return sorter( data );
	};
	Select2CollectionResultsAdapter.prototype.highlightFirstItem = function() {
		var $options = this.$results
			.find( '.select2-results__option[aria-selected]' );
		var $selected = $options.filter( '[aria-selected=true]' );
		// Check if there are any selected options
		if( $selected.length > 0 ) {
			// If there are selected options, highlight the first
			$selected.first().trigger( 'mouseenter' );
		} else {
			// If there are no selected options, highlight the first option
			// in the dropdown
			$options.first().trigger( 'mouseenter' );
		}
		this.ensureHighlightVisible();
	};
	Select2CollectionResultsAdapter.prototype.setClasses = function() {
		var self = this;
		this.data.current( function( selected ) {
			var selectedIds = selected.map( function( s ) {
				return s.id.toString();
			} );
			var $options = self.$results.find( '.select2-results__option[aria-selected]' );
			$options.each( function() {
				var $option = $( this );
				var item = Utils.GetData( this, 'data' );
				// id needs to be converted to a string when comparing
				var id = '' + item.id;
				if( ( item.element != null && item.element.selected ) || ( item.element == null && arr_inArray( id, selectedIds ) > -1 ) ) {
					$option.attr( 'aria-selected', 'true' );
				} else {
					$option.attr( 'aria-selected', 'false' );
				}
			} );
		} );
	};
	Select2CollectionResultsAdapter.prototype.showLoading = function( params ) {
		this.hideLoading();
		var loadingMore = this.options.get( 'translations' ).get( 'searching' );
		var loading = {
			disabled: true,
			loading: true,
			text: loadingMore( params ),
		};
		var $loading = this.option( loading );
		$loading.className += ' loading-results';
		this.$results.prepend( $loading );
	};
	Select2CollectionResultsAdapter.prototype.hideLoading = function() {
		this.$results.find( '.loading-results' ).remove();
	};
	Select2CollectionResultsAdapter.prototype.option = function( data ) {
		var option = document.createElement( 'li' );
		option.className = 'select2-results__option';
		var attrs = {
			'role': 'treeitem',
			'aria-selected': 'false',
		};
		if( data.disabled ) {
			delete attrs['aria-selected'];
			attrs['aria-disabled'] = 'true';
		}
		if( data.id == null ) {
			delete attrs['aria-selected'];
		}
		if( data._resultId != null ) {
			option.id = data._resultId;
		}
		if( data.title ) {
			option.title = data.title;
		}
		if( data.children ) {
			attrs.role = 'group';
			attrs['aria-label'] = data.text;
			delete attrs['aria-selected'];
		}
		for( var attr in attrs ) {
			if( !attrs.hasOwnProperty(attr) ) continue;
			option.setAttribute(attr,attrs[attr]);
		}
		if( data.children ) {
			var $option = $( option );
			var label = document.createElement( 'strong' );
			label.className = 'select2-results__group';
			//var $label = $(label);
			this.template( data, label );
			var $children = [];
			for( var c = 0; c < data.children.length; c++ ) {
				var $child = this.option( data.children[c] );
				$children.push( $child );
			}
			var $childrenContainer = $( '<ul></ul>', { 'class': 'select2-results__options select2-results__options--nested' } );
			$childrenContainer.append( $children );
			$option.append( label );
			$option.append( $childrenContainer );
		} else {
			this.template( data, option );
		}
		Utils.StoreData( option, 'data', data );
		return option;
	};

	Select2CollectionResultsAdapter.prototype.bind = function( container, $container ) {
		var self = this;
		var id = container.id + '-results';
		this.$results.attr( 'id', id );
		container.on( 'results:all', function( params ) {
			self.clear();
			self.append( params.data );
			if( container.isOpen() ) {
				self.setClasses();
				self.highlightFirstItem();
			}
		} );
		container.on( 'results:append', function( params ) {
			self.append( params.data );
			if( container.isOpen() ) {
				self.setClasses();
			}
		} );
		container.on( 'query', function( params ) {
			self.hideMessages();
			self.showLoading( params );
		} );
		container.on( 'select', function() {
			if( !container.isOpen() ) {
				return;
			}
			self.setClasses();
			self.highlightFirstItem();
		} );
		container.on( 'unselect', function() {
			if( !container.isOpen() ) {
				return;
			}
			self.setClasses();
			self.highlightFirstItem();
		} );
		container.on( 'open', function() {
			// When the dropdown is open, aria-expended="true"
			self.$results.attr( 'aria-expanded', 'true' );
			self.$results.attr( 'aria-hidden', 'false' );
			self.setClasses();
			self.ensureHighlightVisible();
		} );
		container.on( 'close', function() {
			// When the dropdown is closed, aria-expended="false"
			self.$results.attr( 'aria-expanded', 'false' );
			self.$results.attr( 'aria-hidden', 'true' );
			self.$results.removeAttr( 'aria-activedescendant' );
		} );
		container.on( 'results:toggle', function() {
			var $highlighted = self.getHighlightedResults();
			if( $highlighted.length === 0 ) {
				return;
			}
			$highlighted.trigger( 'mouseup' );
		} );
		container.on( 'results:select', function() {
			var $highlighted = self.getHighlightedResults();
			if( $highlighted.length === 0 ) {
				return;
			}
			var data = Utils.GetData( $highlighted[0], 'data' );
			if( $highlighted.attr( 'aria-selected' ) == 'true' ) {
				self.trigger( 'select', { data: data } );
			} else {
				self.trigger( 'select', { data: data } );
			}
		} );
		container.on( 'results:previous', function() {
			var $highlighted = self.getHighlightedResults();
			var $options = self.$results.find( '[aria-selected]' );
			var currentIndex = $options.index( $highlighted );

			// If we are already at te top, don't move further
			if( currentIndex === 0 ) {
				return;
			}

			var nextIndex = currentIndex - 1;

			// If none are highlighted, highlight the first
			if( $highlighted.length === 0 ) {
				nextIndex = 0;
			}

			var $next = $options.eq( nextIndex );
			$next.trigger( 'mouseenter' );
			var currentOffset = self.$results.offset().top;
			var nextTop = $next.offset().top;
			var nextOffset = self.$results.scrollTop() + ( nextTop - currentOffset );

			if( nextIndex === 0 ) {
				self.$results.scrollTop( 0 );
			} else if( nextTop - currentOffset < 0 ) {
				self.$results.scrollTop( nextOffset );
			}
		} );

		container.on( 'results:next', function() {
			var $highlighted = self.getHighlightedResults();
			var $options = self.$results.find( '[aria-selected]' );
			var currentIndex = $options.index( $highlighted );
			var nextIndex = currentIndex + 1;

			// If we are at the last option, stay there
			if( nextIndex >= $options.length ) {
				return;
			}

			var $next = $options.eq( nextIndex );
			$next.trigger( 'mouseenter' );
			var currentOffset = self.$results.offset().top + self.$results.outerHeight( false );
			var nextBottom = $next.offset().top + $next.outerHeight( false );
			var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

			if( nextIndex === 0 ) {
				self.$results.scrollTop( 0 );
			} else if( nextBottom > currentOffset ) {
				self.$results.scrollTop( nextOffset );
			}
		} );

		container.on( 'results:focus', function( params ) {
			params.element.addClass( 'select2-results__option--highlighted' );
		} );

		container.on( 'results:message', function( params ) {
			self.displayMessage( params );
		} );

		if( $.fn.mousewheel ) {
			this.$results.on( 'mousewheel', function( e ) {
				var top = self.$results.scrollTop();
				var bottom = self.$results.get( 0 ).scrollHeight - top + e.deltaY;
				var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
				var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

				if( isAtTop ) {
					self.$results.scrollTop( 0 );
					e.preventDefault();
					e.stopPropagation();
				} else if( isAtBottom ) {
					self.$results.scrollTop(
						self.$results.get( 0 ).scrollHeight - self.$results.height()
					);
					e.preventDefault();
					e.stopPropagation();
				}
			} );
		}

		this.$results.on( 'mouseup', '.select2-results__option[aria-selected]', function( evt ) {
			var $this = $( this );
			var data = Utils.GetData( this, 'data' );

			if( $this.attr( 'aria-selected' ) === 'true' ) {
				if( self.options.get( 'multiple' ) ) {
					self.trigger( 'unselect', {
						originalEvent: evt,
						data: data,
					} );
				} else {
					self.trigger( 'select', {
						data: data,
					} );
				}
				return;
			}

			self.trigger( 'select', {
				originalEvent: evt,
				data: data,
			} );
		} );

		this.$results.on( 'mouseenter', '.select2-results__option[aria-selected]', function( evt ) {
			var data = Utils.GetData( this, 'data' );
			self.getHighlightedResults().removeClass( 'select2-results__option--highlighted' );

			self.trigger( 'results:focus', {
				data: data,
				element: $( this ),
			} );
		} );
	};

	Select2CollectionResultsAdapter.prototype.getHighlightedResults = function() {
		var $highlighted = this.$results.find( '.select2-results__option--highlighted' );

		return $highlighted;
	};

	Select2CollectionResultsAdapter.prototype.destroy = function() {
		this.$results.remove();
	};

	Select2CollectionResultsAdapter.prototype.ensureHighlightVisible = function() {
		var $highlighted = this.getHighlightedResults();

		if( $highlighted.length === 0 ) {
			return;
		}

		var $options = this.$results.find( '[aria-selected]' );
		var currentIndex = $options.index( $highlighted );
		var currentOffset = this.$results.offset().top;
		var nextTop = $highlighted.offset().top;
		var nextOffset = this.$results.scrollTop() + ( nextTop - currentOffset );
		var offsetDelta = nextTop - currentOffset;
		nextOffset -= $highlighted.outerHeight( false ) * 2;

		if( currentIndex <= 2 ) {
			this.$results.scrollTop( 0 );
		} else if( offsetDelta > this.$results.outerHeight() || offsetDelta < 0 ) {
			this.$results.scrollTop( nextOffset );
		}
	};

	Select2CollectionResultsAdapter.prototype.template = function( result, container ) {
		var template = this.options.get( 'templateResult' );
		var escapeMarkup = this.options.get( 'escapeMarkup' );
		var content = template( result, container );
		if( content == null ) {
			container.style.display = 'none';
		} else if( typeof content === 'string' ) {
			container.innerHTML = escapeMarkup( content );
		} else {
			$( container ).append( content );
		}
	};

	return Select2CollectionResultsAdapter;
} );





// enables setting css classes of source select also on select2 container
$.fn.select2.amd.define( 'mjSelect2ContainerCssAdapterFoo', [
	'jquery',
	'select2/utils',
	'select2/selection/single',
	'select2/selection/placeholder',
	'select2/selection/eventRelay',
], function( $, Utils, SingleSelection, Placeholder, EventRelay ) {

	function _rejectCssClass( clazz ) {
		return null;
	}
	function _syncCssClasses( $dest, $src, adapter ) {
		var sc = x_split( str_trim( $src.attr( 'class' ) ), ' ' ), i, l = sc.length, nc;
		for( i = 0; i < l; ++i ) if( ( nc = adapter( sc[i] ) ) !== null ) $dest.addClass( nc );
	}
	function mjSelect2ContainerCssAdapterFoo( $element, options ) {
		mjSelect2ContainerCssAdapterFoo.__super__.constructor.apply( this, arguments );
	}

	Utils.Extend( mjSelect2ContainerCssAdapterFoo, SingleSelection );

	mjSelect2ContainerCssAdapterFoo.prototype.bind = function( container, $container ) {
		mjSelect2ContainerCssAdapterFoo.__super__.bind.apply( this, arguments );

		var containerCssClass = this.options.get( 'containerCssClass' ) || '';
		if( 'function' === typeof ( containerCssClass ) ) containerCssClass = containerCssClass( this.$element );

		var containerCssAdapter = this.options.get( 'adaptContainerCssClass' ) || _rejectCssClass;
		var containerCss = this.options.get( 'containerCss' ) || {};
		if( 'function' === typeof ( containerCss ) ) containerCss = containerCss( this.$element );
		_syncCssClasses( $container, this.$element, containerCssAdapter );

		$container.css( containerCss ).addClass( containerCssClass );
	};

	var adapter = mjSelect2ContainerCssAdapterFoo;
	// if( false ) {
	// 	// +Placeholder
	// 	adapter = Utils.Decorate(adapter,Placeholder);
	// 	// +AllowClear ?
	// 	adapter = Utils.Decorate(adapter,AllowClear);
	// }

	// +SelectionSearch ?
	//adapter = Utils.Decorate(adapter,SelectionSearch);
	// +EventRelay
	adapter = Utils.Decorate( adapter, EventRelay );
	return adapter;
} );



$.fn.select2.amd.define( 'mjSelect2ContainerCssAdapterMultiFoo', [
	'jquery',
	'select2/utils',
	'select2/selection/multiple',
	'select2/selection/placeholder',
	'select2/selection/allowClear',
	'select2/selection/search',
	'select2/selection/eventRelay',
], function( $, Utils, MultipleSelection, Placeholder, AllowClear, SelectionSearch, EventRelay ) {

	function _rejectCssClass( clazz ) {
		return null;
	}
	function _syncCssClasses( $dest, $src, adapter ) {
		var sc = x_split( str_trim( $src.attr( 'class' ) ), ' ' ), i, l = sc.length, nc;
		for( i = 0; i < l; ++i ) if( ( nc = adapter( sc[i] ) ) !== null ) $dest.addClass( nc );
	}
	function mjSelect2ContainerCssAdapterMultiFoo( $element, options ) {
		mjSelect2ContainerCssAdapterMultiFoo.__super__.constructor.apply( this, arguments );
	}

	Utils.Extend( mjSelect2ContainerCssAdapterMultiFoo, MultipleSelection );

	mjSelect2ContainerCssAdapterMultiFoo.prototype.bind = function( container, $container ) {
		mjSelect2ContainerCssAdapterMultiFoo.__super__.bind.apply( this, arguments );

		var containerCssClass = this.options.get( 'containerCssClass' ) || '';
		if( 'function' === typeof ( containerCssClass ) ) containerCssClass = containerCssClass( this.$element );

		var containerCssAdapter = this.options.get( 'adaptContainerCssClass' ) || _rejectCssClass;
		var containerCss = this.options.get( 'containerCss' ) || {};
		if( 'function' === typeof ( containerCss ) ) containerCss = containerCss( this.$element );
		_syncCssClasses( $container, this.$element, containerCssAdapter );

		$container.css( containerCss ).addClass( containerCssClass );
	};

	var adapter = mjSelect2ContainerCssAdapterMultiFoo;
	// if( false ) {
	// 	// +Placeholder
	// 	adapter = Utils.Decorate(adapter,Placeholder);
	// 	// +AllowClear ?
	// 	adapter = Utils.Decorate(adapter,AllowClear);
	// }

	// +SelectionSearch
	adapter = Utils.Decorate( adapter, SelectionSearch );
	// +EventRelay
	adapter = Utils.Decorate( adapter, EventRelay );
	return adapter;
} );


/**
 *  Allows single-<select> dropdowns with big numbers of options,
 *  to be useable - at least in regard to UI response time.
 *
 *	Usage:
 * 		$elem.select2( {
 * 			ajax: {},
 *			dataAdapter: $.fn.select2.amd.require('mjSelect2CustomPaginationDataAdapter'),
 *			pageSize: 100,
 *			data: [ {id:'1',text:'eins'}, {id:'2',text:'zwei',disabled:true}, ... ]
 * 		} );
 **/
$.fn.select2.amd.define( 'mjSelect2CustomPaginationDataAdapter', [
	'select2/data/array',
	'select2/utils',
], function( ArrayAdapter, Utils ) {
	function mjSelect2RcptsForSendAdapter( $element, options ) {
		mjSelect2RcptsForSendAdapter.__super__.constructor.call( this, $element, options );
		this.pageSize = options.get( 'pageSize' ) || 100;
	}
	Utils.Extend( mjSelect2RcptsForSendAdapter, ArrayAdapter );

	mjSelect2RcptsForSendAdapter.prototype.query = function( params, callback ) {
		var self = this;
		if( !( 'page' in params ) ) params.page = 1;
		/*
			  1. uses ArrayAdapter.prototype.query to get list of options (cares about crude back-and-forth mapping between DOM Option elements and plain data nodes),
			2. then applies pagination to the results,
		*/
		ArrayAdapter.prototype.query.call( this, params, function( data ) {
			var filtered_data = data.results;
			var end_idx = params.page * self.pageSize;
			var sta_idx = end_idx - self.pageSize;
			callback( {
				results: filtered_data.slice( sta_idx, end_idx ),
				pagination: {
					more: end_idx < filtered_data.length,
				},
			} );
		} );
	};
	return mjSelect2RcptsForSendAdapter;
}
);

// select2 defaults

$.fn.select2.defaults.set( 'theme', 'classic' );
$.fn.select2.defaults.set( 'minimumResultsForSearch', 10 );
$.fn.select2.defaults.set( 'dropdownAutoWidth', true );
$.fn.select2.defaults.set( 'selectionAdapter', $.fn.select2.amd.require( 'mjSelect2ContainerCssAdapterFoo' ) );
$.fn.select2.defaults.set( 'adaptContainerCssClass', function( c ) {
	return c;
} );

var mjSelect2MatcherOrg = $.fn.select2.defaults.defaults.matcher;
$.fn.select2.defaults.set( 'matcher', function mjSelect2Matcher( params, data ) {
	if( !params.hasOwnProperty('term') ) return data;
	if( !params.hasOwnProperty('_stripped_term') ) {
		// compute _stripped_term once (and re-use in upcoming calls)
		params._stripped_term = str_trim(params.term);
	}

	if( params._stripped_term==='' ) {
		// match empty term
		return data;
	}

	// try to match by id
	if( data.hasOwnProperty('id') && data.id==params._stripped_term ) {
		return data;
	}

	// use default matcher for anything else
	return mjSelect2MatcherOrg(params,data);
} );












export function convertToSelect2WithDefaultFit( $elems, fit2container, s2_opts ) {
	if( s2_opts === undefined ) s2_opts = {};

	if( fit2container ) {
		$elems.each( function() {
			var $elem = $( this );
			if( !$elem.data( 'select2' ) ) {
				var css_width = $elem[0].style.width;
				if( css_width ) {
					$elem.select2( s2_opts ).next( '.select2-container' ).css( 'width', css_width );
				} else {
					s2_opts.width = 'style';
					$elem.select2( s2_opts );
				}
			}
		} );
	} else {
		$elems.each( function() {
			var $elem = $( this );
			var sc1w = $elem.css( 'width' );
			var sc1minw = $elem.css( 'min-width' );
			var sc1maxw = $elem.css( 'max-width' );

			$elem.select2( s2_opts );

			// workaround for forcing use of css width on select2 container - e.g. when the parent element was hidden
			// (https://github.com/select2/select2/issues/3278)
			var css = {};
			if( sc1w === '0px' && sc1minw && sc1minw != '0px' && sc1minw != 'none' ) css['min-width'] = sc1minw;
			if( !( sc1w === '0px' || sc1w === '2px' ) ) css['width'] = sc1w;
			if( sc1minw && sc1minw != '0px' && sc1minw != 'none' ) css['min-width'] = sc1minw;
			if( sc1maxw && sc1maxw != '0px' && sc1maxw != 'none' ) css['max-width'] = sc1maxw;
			$elem.next( '.select2-container' ).css( css );
		} );
	}
}



export let more_select2_widget_init = function() {

	$( document )
		.on( 'focus.mjSelect2WidgetHooks', 'span.select2.select2-container:not(.select2-container--focus)', function _select2_on_focus( xe ) {
			var s2e = $( this ),
				se = s2e.prev( 'select.select2-hidden-accessible' );
			if( !se.data( 'mjSelect2WidgetHooksAttached' ) ) {
				se.data( 'mjSelect2WidgetHooksAttached', true );
				se.select2( 'on', 'keypress', function _select2_on_keypressA( evt ) {
					// NOTE: here, "this" is instance of Select2

					if( this.$container && this.$container.hasClass( 'select2-container--disabled' ) ) return;
					if( evt.which >= 37 && evt.which <= 40 ) {									// LEFT, UP, RIGHT, DOWN
						if( this.isOpen && !this.isOpen() ) {
							this.open();
							evt.preventDefault();
						}
					} else if( evt.which === 27 && !evt.isDefaultPrevented() ) {
						if( this.isOpen && !this.isOpen() ) {
							// yield focus: dont prevent default -> so a higher-level handler may handle this event now:
							this.$selection.blur();
						}
					}

				} );
			}
		} )
		.on( 'select2:open.mjSelect2ResultHooks', 'select', function _select2_on_open( oe ) {
			var self = $( this );
			if( !self.data( 'mjSelect2ResultHooksAttached' ) ) {
				self.data( 'mjSelect2ResultHooksAttached', true );
				self.select2( 'on', 'keypress', function _select2_on_keypressB( evt ) {
					// NOTE: here, "this" is instance of Select2

					if( !this.isOpen() ) return;
					if( this.$container.hasClass( 'select2-container--disabled' ) ) return;

					var sfld = this.$dropdown.find( '.select2-search__field' );
					var sval = sfld.length ? sfld.val() : '';
					var k = evt.which;
					if( ( ( k === 33 || k === 34 ) ) ||					// (none)									  +  (PAGE_UP or PAGE_DOWN)
						( ( sval.length === 0 | evt.ctrlKey || evt.metaKey ) && ( k === 35 || k === 36 ) ) ) {					// (empty search term or ctrlKey or metaKey)  +  (END or HOME)
						var $items = this.$results.find( '.select2-results__option[aria-selected]' ),
							hl_idx = $items.index( $items.filter( '.select2-results__option--highlighted' ) );
						if( k === 33 ) hl_idx = hl_idx - 5;													// PAGE_UP
						else if( k === 34 ) hl_idx = hl_idx + 5;												// PAGE_DOWN
						else if( k === 35 ) hl_idx = $items.length - 1;											// END
						else if( k === 36 ) hl_idx = 0;														// HOME
						hl_idx = clip( hl_idx, 0, $items.length - 1 );
						evt.preventDefault();
						var $new_item = $items.eq( hl_idx ).trigger( 'mouseenter' );
						// scroll results list so that highlighted item is visible
						if( hl_idx <= 2 ) {
							this.$results.scrollTop( 0 );
						} else {
							var itemHeight = $new_item.outerHeight( false );
							var offsetDelta = $new_item.offset().top - this.$results.offset().top;
							if( hl_idx >= $items.length - 1 || offsetDelta + itemHeight > this.$results.outerHeight() || offsetDelta < 0 ) {
								this.$results.scrollTop( this.$results.scrollTop() + offsetDelta - 1 * itemHeight );
							}
						}
					}

				} );
			}
		} )
		.on( 'click', '.select2-container--disabled', function( ce ) {
			// dont allow focus on disabled select2 containers
			$( this ).find( '.select2-selection' ).blur();
		} );


	function _select2_markMatch( text, term, spanClassName ) {
		var $result = $('<span></span>',spanClassName?{'class':spanClassName}:null);
		if( term==='' ) {
			// optimized non-search case..
			return $result.append(document.createTextNode(text));
		}

		var match = text.toUpperCase().indexOf(term.toUpperCase());
		if( match < 0 ) {
			// optimized "unmatched" case..
			return $result.append(document.createTextNode(text));
		}
		$result.append(document.createTextNode(text.substring(0,match)));
		$('<span class="select2-rendered__match"></span>')
			.append(document.createTextNode(text.substring(match,match+term.length)))
			.appendTo($result);
		return $result.append(document.createTextNode(text.substring(match+term.length)));
	}

	window._mj_select2_markMatch = _select2_markMatch;
	window._mj_cur_select2_query = {};

	if( $.fn.select2 ) {
		$.fn.select2.defaults.set( 'templateResult', function _select2_default_templateResult( item, li ) {
			//console.log({fn:'templateResult',item,li});

			if( item && item.element && item.element.style.cssText.length ) li.style.cssText = item.element.style.cssText;
			if( item.loading ) return item.text;
			var term = window._mj_cur_select2_query.term || '';
			var spanClassName = item.class || ( item.element && item.element.className ) || '';

			// // store item as "data-item" on <li> element
			// li.dataset.item = item.element && item.element.dataset && item.element.dataset.item ? item.element.dataset.item : null;

			return _select2_markMatch(item.text,term,spanClassName);
		} );
	} else {
		// eslint-disable-next-line no-console
		console.log('attaching templateResult callback as option to select2 config failed');
	}

};

